// Inline SVG icon set ported from the Claude Designer bundle.
// Each export is a component receiving standard SVG props.

import type { SVGProps } from 'react';

type P = SVGProps<SVGSVGElement>;

const sw = 'currentColor';

export const Icon = {
  Sun: (p: P) => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={sw} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
    </svg>
  ),
  Moon: (p: P) => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={sw} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z" />
    </svg>
  ),
  Plus: (p: P) => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={sw} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M12 5v14M5 12h14" />
    </svg>
  ),
  Star: (p: P) => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" stroke={sw} strokeWidth="0.5" {...p}>
      <polygon points="12 2 15 8.5 22 9.3 17 14 18.2 21 12 17.8 5.8 21 7 14 2 9.3 9 8.5 12 2" />
    </svg>
  ),
  Check: (p: P) => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={sw} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <polyline points="20 6 9 17 4 12" />
    </svg>
  ),
  Alert: (p: P) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={sw} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
      <line x1="12" y1="9" x2="12" y2="13" />
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  ),
  X: (p: P) => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={sw} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  ),
  Copy: (p: P) => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={sw} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <rect x="9" y="9" width="13" height="13" rx="2" />
      <path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" />
    </svg>
  ),
  ChevronDown: (p: P) => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={sw} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <polyline points="6 9 12 15 18 9" />
    </svg>
  ),
  ArrowRight: (p: P) => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={sw} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <line x1="5" y1="12" x2="19" y2="12" />
      <polyline points="12 5 19 12 12 19" />
    </svg>
  ),
  Send: (p: P) => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={sw} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <line x1="22" y1="2" x2="11" y2="13" />
      <polygon points="22 2 15 22 11 13 2 9 22 2" />
    </svg>
  ),
  Stop: (p: P) => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" {...p}>
      <rect x="6" y="6" width="12" height="12" rx="2" />
    </svg>
  ),
  Upload: (p: P) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={sw} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
      <polyline points="17 8 12 3 7 8" />
      <line x1="12" y1="3" x2="12" y2="15" />
    </svg>
  ),
  Scan: (p: P) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={sw} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M3 7V5a2 2 0 012-2h2M17 3h2a2 2 0 012 2v2M21 17v2a2 2 0 01-2 2h-2M7 21H5a2 2 0 01-2-2v-2" />
      <line x1="7" y1="12" x2="17" y2="12" />
    </svg>
  ),
  Edit: (p: P) => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={sw} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" />
      <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" />
    </svg>
  ),
  Cpu: (p: P) => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={sw} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <rect x="4" y="4" width="16" height="16" rx="2" />
      <rect x="9" y="9" width="6" height="6" />
      <line x1="9" y1="2" x2="9" y2="4" />
      <line x1="15" y1="2" x2="15" y2="4" />
      <line x1="9" y1="20" x2="9" y2="22" />
      <line x1="15" y1="20" x2="15" y2="22" />
      <line x1="20" y1="9" x2="22" y2="9" />
      <line x1="20" y1="14" x2="22" y2="14" />
      <line x1="2" y1="9" x2="4" y2="9" />
      <line x1="2" y1="14" x2="4" y2="14" />
    </svg>
  ),
  Shield: (p: P) => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={sw} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    </svg>
  ),
  Sparkles: (p: P) => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={sw} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9L12 3z" />
      <path d="M19 17l.7 1.8L21.5 19.5l-1.8.7L19 22l-.7-1.8L16.5 19.5l1.8-.7L19 17z" />
    </svg>
  ),
  Trash: (p: P) => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={sw} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <polyline points="3 6 5 6 21 6" />
      <path d="M19 6l-2 14a2 2 0 01-2 2H9a2 2 0 01-2-2L5 6" />
      <path d="M10 11v6M14 11v6" />
    </svg>
  ),
  Github: (p: P) => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" {...p}>
      <path d="M12 .5C5.65.5.5 5.65.5 12c0 5.08 3.29 9.39 7.86 10.91.58.11.79-.25.79-.56v-2c-3.2.7-3.87-1.36-3.87-1.36-.52-1.33-1.28-1.68-1.28-1.68-1.04-.71.08-.7.08-.7 1.16.08 1.77 1.19 1.77 1.19 1.03 1.76 2.7 1.25 3.36.96.1-.74.4-1.25.73-1.54-2.56-.29-5.25-1.28-5.25-5.7 0-1.26.45-2.29 1.19-3.1-.12-.29-.52-1.47.11-3.06 0 0 .97-.31 3.18 1.18.92-.26 1.91-.39 2.9-.39.99 0 1.98.13 2.9.39 2.21-1.49 3.18-1.18 3.18-1.18.63 1.59.23 2.77.11 3.06.74.81 1.19 1.84 1.19 3.1 0 4.43-2.69 5.4-5.26 5.69.41.35.78 1.05.78 2.11v3.13c0 .31.21.67.79.56C20.21 21.39 23.5 17.08 23.5 12 23.5 5.65 18.35.5 12 .5z" />
    </svg>
  ),
  Search: (p: P) => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={sw} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <circle cx="11" cy="11" r="7" />
      <line x1="21" y1="21" x2="16.65" y2="16.65" />
    </svg>
  ),
  Activity: (p: P) => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={sw} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
    </svg>
  ),
  Network: (p: P) => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={sw} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <circle cx="12" cy="12" r="3" />
      <circle cx="5" cy="5" r="2" />
      <circle cx="19" cy="5" r="2" />
      <circle cx="5" cy="19" r="2" />
      <circle cx="19" cy="19" r="2" />
      <line x1="7" y1="6" x2="10" y2="10" />
      <line x1="17" y1="6" x2="14" y2="10" />
      <line x1="7" y1="18" x2="10" y2="14" />
      <line x1="17" y1="18" x2="14" y2="14" />
    </svg>
  ),
  Folder: (p: P) => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={sw} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M22 19a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2h5l2 3h9a2 2 0 012 2z" />
    </svg>
  ),
  Globe: (p: P) => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={sw} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <circle cx="12" cy="12" r="10" />
      <line x1="2" y1="12" x2="22" y2="12" />
      <path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z" />
    </svg>
  ),
  Hex: (p: P) => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={sw} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <polygon points="12 2 21 7 21 17 12 22 3 17 3 7" />
    </svg>
  ),
  Book: (p: P) => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={sw} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M4 19.5A2.5 2.5 0 016.5 17H20" />
      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z" />
    </svg>
  ),
  Wand: (p: P) => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={sw} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M15 4V2M15 16v-2M8 9h2M20 9h2M17.8 11.8L19 13M15 9h0M17.8 6.2L19 5M3 21l9-9M12.2 6.2L11 5" />
    </svg>
  ),
} as const;

export type IconName = keyof typeof Icon;
